import { useTranslation } from "react-i18next";

/** Switches between English and Urdu (which flips the document to RTL). */
export function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const isUrdu = i18n.resolvedLanguage === "ur";

  const toggle = () => {
    void i18n.changeLanguage(isUrdu ? "en" : "ur");
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t("actions.toggleLanguage")}
      className="inline-flex h-9 items-center justify-center gap-1 rounded-md border border-border px-3 text-sm font-medium text-fg-muted hover:bg-bg-subtle hover:text-fg"
    >
      {/* Show the language you'd switch TO. */}
      <span aria-hidden="true">{isUrdu ? "EN" : "اردو"}</span>
    </button>
  );
}
